export default __webpack_public_path__ + "locales/bg/Article.json?hash=fede382e67a91908d47df9e1d1c402a5";